<template>
  <div>
    <div ref="quillEditor" class="`quill-editor input-text-size pa-0  ${this.classes}`"
   ></div>
  </div>

</template>

<script>
import Quill from 'quill';
import 'quill/dist/quill.snow.css'; // Import the Quill styles

// Extend Quill to include custom fonts
const Font = Quill.import('formats/font');
Font.whitelist = [
  'sans-serif',
  'Montserrat',
  'EBGaramond',
  'Arial',
  'ArialNarrow',
  'CourierNew',
  'TimesNewRoman',
  'Verdana',
  'GillSans',
];
Quill.register(Font, true);

export default {
  name: 'TextEditorField',
  data() {
    return {
      editor: null, // Quill editor instance
      // content: '', // The content of the
      toolbarOptions: [
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        ['bold', 'italic', 'underline'], // toggled buttons
        // 'strike'
        // ['blockquote', 'code-block'],
        // ["link", "image", "video", "formula"],
        ['link'],

        // [{ header: 1 }, { header: 2 }],
        // custom button values
        // [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        // [{ script: "sub" }, { script: "super" }], // superscript/subscript
        // [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
        // [{ direction: "rtl" }], // text direction

        // [{ size: ["small", false, "large", "huge"] }], // custom dropdown

        [{ color: [] }], // dropdown with defaults from theme
        // { background: [] }
        [
          {
            font: [
              'Sans Serif',
              'Montserrat',
              'EBGaramond',
              'Arial',
              'ArialNarrow',
              'CourierNew',
              'TimesNewRoman',
              'Verdana',
              'GillSans',
            ],
          },
        ],
        [{ align: [] }],

        ['clean'], // remove formatting button
      ],
    };
  },
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    classes: {
      type: String,
      default: '',
    },
  },
  mounted() {
    this.initializeEditor();
    this.setEditorContent(this.value);
    this.registerEditorEvent();
  },
  watch: {
    value(newValue) {
      this.updateEditorContent(newValue);
    },
  },
  methods: {
    initializeEditor() {
      this.editor = new Quill(this.$refs.quillEditor, {
        theme: 'snow',
        placeholder: this.placeholder,

        modules: {
          toolbar: this.toolbarOptions,
          //  {
          //   container: "#toolbar", // Custom toolbar selector
          // },
        },
      });
    },
    setEditorContent(content) {
      if (content !== this.editor.root.innerHTML) {
        this.editor.root.innerHTML = content;
      }
    },
    registerEditorEvent() {
      this.editor.on('text-change', () => {
        // Listen for text changes and update the content
        const content = this.editor.root.innerHTML;
        this.$emit('input', content); // Emit content to parent component
      });
    },
    updateEditorContent(newContent) {
      // Update editor content if the v-model value changes and is different
      if (newContent && newContent !== this.editor.root.innerHTML) {
        this.editor.root.innerHTML = newContent;
      }
    },
  },
};
</script>

<style>

/* Ensure toolbar buttons are also adjusted */

/* Ensure toolbar buttons are also adjusted */
.ql-toolbar .ql-formats {
  height: 40px; /* Make the toolbar items match the new toolbar height */
}

.ql-editor {
  height: 200px;
  background-color: #fff;
}

.ql-editor h1 {
  font-weight: normal; /* Removes the default bold style */
}
.ql-editor h2 {
  font-weight: normal;
}
.ql-editor h3 {
  font-weight: normal;
}
.ql-editor h4 {
  font-weight: normal;
}
.ql-editor h5 {
  font-weight: normal;
}
.ql-editor h6 {
  font-weight: normal;
}

.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Montserrat"]::before {
  content: "Montserrat";
  font-family: "Montserrat", sans-serif !important;
}
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="EBGaramond"]::before {
  content: "Garamond";
  font-family: "EBGaramond", sans-serif !important;
}
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Arial"]::before {
  content: "Arial";
  font-family: "Arial", sans-serif !important;
}
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="ArialNarrow"]::before {
  content: "Arial Narrow";
  font-family: "ArialNarrow", sans-serif !important;
}
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="CourierNew"]::before {
  content: "Courier New";
  font-family: "CourierNew", sans-serif !important;
}
.ql-snow
  .ql-picker.ql-font
  .ql-picker-item[data-value="TimesNewRoman"]::before {
  content: "Times New Roman";
  font-family: "TimesNewRoman", sans-serif !important;
}
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Verdana"]::before {
  content: "Verdana";
  font-family: "Verdana", sans-serif !important;
}
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="GillSans"]::before {
  content: "Gill Sans";
  font-family: "GillSans", sans-serif !important;
}

/* Apply styles for the selected value in the label */
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="EBGaramond"]::before {
  content: "Garamond";
  font-family: "EBGaramond", sans-serif !important;
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Montserrat"]::before {
  content: "Montserrat";
  font-family: "Montserrat", sans-serif !important;
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Arial"]::before {
  content: "Arial";
  font-family: "Arial", sans-serif !important;
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="ArialNarrow"]::before {
  content: "Arial Narrow";
  font-family: "ArialNarrow", sans-serif !important;
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="CourierNew"]::before {
  content: "Courier New";
  font-family: "CourierNew", sans-serif !important;
}
.ql-snow
  .ql-picker.ql-font
  .ql-picker-label[data-value="TimesNewRoman"]::before {
  content: "Times New Roman";
  font-family: "TimesNewRoman", sans-serif !important;
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Verdana"]::before {
  content: "Verdana";
  font-family: "Verdana", sans-serif !important;
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="GillSans"]::before {
  content: "Gill Sans";
  font-family: "GillSans", sans-serif !important;
}
/* apply styles for input box text */
.ql-font-Montserrat {
  font-family: "Montserrat", sans-serif !important;
}
.ql-font-EBGaramond {
  font-family: "Arial", sans-serif !important;
}
.ql-font-Arial {
  font-family: "Arial", sans-serif !important;
}
.ql-font-ArialNarrow {
  font-family: "ArialNarrow", sans-serif !important;
}
.ql-font-CourierNew {
  font-family: "CourierNew", sans-serif !important;
}
.ql-font-TimesNewRoman {
  font-family: "CourierNew", sans-serif !important;
}
.ql-font-Verdana {
  font-family: "Verdana", sans-serif !important;
}
.ql-font-GillSans {
  font-family: "GillSans", sans-serif !important;
}
</style>
